module.exports = __webpack_public_path__ + "img/xcb-subject-banner10.df370a81.jpg";